// Deleted accounts are kept for liability with "-deleted" appended to the name, so only show the name itself.
// Cuts at the marker rather than the first "-" so hyphenated names (e.g. Mary-Jane) stay intact.
// Returns "Unknown user" when there's no name to show.
const UseDisplayUserName = (name) => {
    if (typeof name !== "string" || name.trim() === "") return "Unknown user";

    const deletedIndex = name.indexOf("-deleted");
    const displayName = (deletedIndex !== -1 ? name.slice(0, deletedIndex) : name).trim();

    return displayName || "Unknown user";
};

export default UseDisplayUserName;
